export enum batchTransferStatus {
  allSuccessful = "allSuccessful",
  processing = "processing",
  queued = "queued",
  partialSuccessful = "partialSuccessful",
  allFailed = "allFailed",
  otp = "otp",
  otpDispatchFailed = "otpDispatchFailed",
}
